export default __webpack_public_path__ + "static/1315-0aa0ab7a6eb2b2c9f907e866df6f041c.gif";